// extracted by mini-css-extract-plugin
export default {"fixedPosition":"style_fixedPosition__mG2Ki"};